import React, { useEffect } from 'react';
import 'magnific-popup/dist/magnific-popup.css';
import $ from 'jquery';
import 'magnific-popup';
import {Row, Col} from 'react-bootstrap'
import styles from './index.module.scss'

const GalleryCard = (props) => {
  const compData = props;
  useEffect(() => {
    $(document).ready(() => {
      $('.popup-container').magnificPopup({
        delegate: '.popup-trigger',
        type: 'image',
        gallery: {
          enabled: true,
        },
      });
    });
  }, []);

  const openPopup = (event) => {
    event.preventDefault();
    const imageSrc = event.target.getAttribute('data-mfp-src');
    $.magnificPopup.open({
      items: [
        {
          src: imageSrc,
          type: 'image',
        },
      ],
      gallery: {
        enabled: false,
      },
    });
  };

  return (
    <div>
      <Row className='popup-container'>
        {compData?.cardData?.gallery_01 && 
          <Col lg={4} className='mb-4'>
          <div className={styles.galleryWrapper}>
            <img  src={compData?.cardData?.gallery_01} title=""  loading="lazy"/>
            <a
            className="popup-trigger"
            href={compData?.cardData?.gallery_01}
            data-mfp-src={compData?.cardData?.gallery_01}
            onClick={openPopup}
          >
          </a>
          </div>  
        </Col>
        }
        {compData?.cardData?.gallery_02 && 
          <Col lg={4} className='mb-4'>
          <div className={styles.galleryWrapper}>
            <img  src={compData?.cardData?.gallery_02} title=""  loading="lazy"/>
            <a
            className="popup-trigger"
            href={compData?.cardData?.gallery_02}
            data-mfp-src={compData?.cardData?.gallery_02}
            onClick={openPopup}
          >
            
          </a>
          </div>  
        </Col>
        }
        {compData?.cardData?.gallery_03 && 
          <Col lg={4} className='mb-4'>
          <div className={styles.galleryWrapper}>
            <img  src={compData?.cardData?.gallery_03} title=""  loading="lazy"/>
            <a
            className="popup-trigger"
            href={compData?.cardData?.gallery_03}
            data-mfp-src={compData?.cardData?.gallery_03}
            onClick={openPopup}
          >
            
          </a>
          </div>  
        </Col>
        }
        {compData?.cardData?.gallery_04 && 
          <Col lg={4} className='mb-4'>
          <div className={styles.galleryWrapper}>
            <img  src={compData?.cardData?.gallery_04} title=""  loading="lazy"/>
            <a
            className="popup-trigger"
            href={compData?.cardData?.gallery_04}
            data-mfp-src={compData?.cardData?.gallery_04}
            onClick={openPopup}
          >
            
          </a>
          </div>  
        </Col>
        }
        {compData?.cardData?.gallery_05 && 
          <Col lg={4} className='mb-4'>
          <div className={styles.galleryWrapper}>
            <img  src={compData?.cardData?.gallery_05} title=""  loading="lazy"/>
            <a
            className="popup-trigger"
            href={compData?.cardData?.gallery_05}
            data-mfp-src={compData?.cardData?.gallery_05}
            onClick={openPopup}
          >
            
          </a>
          </div>  
        </Col>
        }
        {compData?.cardData?.gallery_06 && 
          <Col lg={4} className='mb-4'>
          <div className={styles.galleryWrapper}>
            <img  src={compData?.cardData?.gallery_06} title=""  loading="lazy"/>
            <a
            className="popup-trigger"
            href={compData?.cardData?.gallery_06}
            data-mfp-src={compData?.cardData?.gallery_06}
            onClick={openPopup}
          >
            
          </a>
          </div>  
        </Col>
        }
      </Row>
    </div>
  );
};

export default GalleryCard;
